module.exports = __webpack_public_path__ + "static/media/pichandy.c984ac46.png";